"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobStatusEnum = void 0;
var JobStatusEnum;
(function (JobStatusEnum) {
    JobStatusEnum["NEW"] = "new";
    JobStatusEnum["WAITING_PREPAYMENT"] = "waiting prepayment";
    JobStatusEnum["OPEN"] = "open";
    JobStatusEnum["PROPOSAL_APPROVAL_PENDING"] = "proposal approval pending";
    JobStatusEnum["ON_HOLD_BEFORE_ACCEPTED"] = "on hold before accepted";
    JobStatusEnum["ACCEPTED"] = "accepted";
    JobStatusEnum["ON_HOLD"] = "on hold";
    JobStatusEnum["APPOINTMENT_CONFIRMED"] = "appointment confirmed";
    JobStatusEnum["STARTED"] = "started";
    JobStatusEnum["FINISHED"] = "finished";
    JobStatusEnum["APPROVAL_PENDING"] = "approval pending";
    JobStatusEnum["CANCELLED"] = "cancelled";
    JobStatusEnum["COMPLETED"] = "completed";
    JobStatusEnum["BRAND_PROPOSAL_APPROVAL_PENDING"] = "brand proposal approval pending";
    JobStatusEnum["INVOICE_SENT"] = "invoice sent";
    JobStatusEnum["CLOSED"] = "closed";
    JobStatusEnum["WAITING_FOR_ONBOARDING"] = "waiting for onboarding";
})(JobStatusEnum = exports.JobStatusEnum || (exports.JobStatusEnum = {}));
//# sourceMappingURL=job-status-enum.js.map